import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { DotsNine } from 'phosphor-react';
import type { PropsWithChildren } from 'react';
import { Children } from 'react';
import { ShellPortalNavigationItem } from './shell-portal';

export const ApplicationSwitch = ({ children }: PropsWithChildren<unknown>) => (
  <ShellPortalNavigationItem.Root>
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="tds-navigation-item">
        <ShellPortalNavigationItem.Content label="Alle Apps" Icon={DotsNine} />
      </DropdownMenu.Trigger>
      {/* This magic helps us combine having a grid, squashing empty cells to no width and having margins only between entries in col 1 and 2 */}
      <DropdownMenu.Content asChild className="tds-application-dropdown p-500 grid grid-cols-[repeat(3,min-content)] [&>:nth-child(3n+2)]:ml-600 [&>:nth-child(3n+3)]:ml-600">
        <menu aria-label="Apps">
          {Children.map(children, child => (<li>{child}</li>))}
        </menu>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  </ShellPortalNavigationItem.Root>
);

